import React, { lazy } from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const tomos = [{
    name: '365-Day Curriculum',
    desc: 'Your complete annual roadmap.'
  }, {
    name: 'Pilates Foundation',
    desc: 'The solid base for beginners.'
  }, {
    name: 'Core Intense',
    desc: 'Center challenge and stability.'
  }, {
    name: 'Flow & Flex',
    desc: 'Liquid transitions and mobility.'
  }, {
    name: 'Power Reformer',
    desc: 'Strength and control sequences.'
  }, {
    name: 'Prop Mastery',
    desc: 'Strategic use of bands, balls, and rings.'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-193">
      <div className="max-w-5xl mx-auto" data-id="element-194">
        <div className="text-center mb-12" data-id="element-195">
          <div className="bg-pilates-lavender/25 text-pilates-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-196">
            THE SOLUTION YOU'VE BEEN WAITING FOR — A 6-IN-1 SYSTEM
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-197">
            6 guides in 1, designed for{' '}
            <span className="italic text-pilates-sage-dark" data-id="element-198">
              movement professionals
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-199">
          <div data-id="element-200">
            <img src="https://cdn.magicpatterns.com/uploads/jR6ACrFLYMAhNeVC3xJcD8/hf_20260602_221642_f266517f-2571-4aed-9d07-491b68f8c948_(1).webp" alt="Pilates Ready 6-in-1 Box Set" className="w-full rounded-2xl shadow-xl" loading="lazy" decoding="async" width="800" height="800" data-id="element-201" />
          </div>

          <div data-id="element-202">
            <p className="text-pilates-slate text-base leading-relaxed mb-6" data-id="element-203">
              <span className="font-bold text-pilates-dark" data-id="element-204">PILATES READY</span>{' '}
              is much more than a simple manual. It is a complete operating
              system that delivers professional sessions, pedagogically
              structured to guarantee flow and authority in the studio.
            </p>

            <ul className="space-y-4 mt-8" data-id="element-205">
              {tomos.map((tomo, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-206">
                  <div className="mt-0.5 bg-pilates-sage/20 p-1 rounded-full text-pilates-sage-dark flex-shrink-0" data-id="element-207">
                    <Check className="w-4 h-4" data-id="element-208" />
                  </div>
                  <div data-id="element-209">
                    <span className="font-bold text-pilates-dark" data-id="element-210">
                      {tomo.name}
                    </span>{' '}
                    <span className="text-pilates-slate" data-id="element-211">— {tomo.desc}</span>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}